import { render, staticRenderFns } from "./ListOrderCantServeV2.vue?vue&type=template&id=5b9d07a7&scoped=true"
import script from "./ListOrderCantServeV2.vue?vue&type=script&lang=js"
export * from "./ListOrderCantServeV2.vue?vue&type=script&lang=js"
import style0 from "./ListOrderCantServeV2.vue?vue&type=style&index=0&id=5b9d07a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d07a7",
  null
  
)

export default component.exports